import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { dateFormate } from '../../../utils/helper';
const DataNotFound = React.lazy(() => import('../../Shared/DataNotFound/index'));

export const AudioModal = ({ audioList }) => {
  return (
    <div>
      <ListGroup style={{ height: '400px', overflow: 'auto' }}>
        {audioList?.length > 0 ? (
          <>
            {audioList?.map((item, index) => {
              return (
                <div key={index} >
                  <ListGroup.Item key={index}>
                    <div className='d-flex'>
                      <div>{item?.file_name}</div>
                      <div>
                        <audio controls >
                          <source src={item?.url || item?.lead_form_image || ''} type="audio/mpeg" />
                          Your browser does not support the audio element.
                        </audio>
                        {/* <AudioPlayer audioUrl={item?.url || item?.lead_form_image} /> */}
                      </div>
                    </div>
                  </ListGroup.Item>
                </div>
              );
            })}
          </>
        ) : (
          <DataNotFound message={'No Recordings available'} />
        )}
      </ListGroup>
    </div>
  );
};
